import React from 'react';
import Alert from '@salesforce/design-system-react/components/alert';
import AlertContainer from '@salesforce/design-system-react/components/alert/container';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import { clearSnapshot, getSyncTime } from '../../services/snapshot';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@salesforce/design-system-react';
import { getDateTimeFromTimestamp } from '../../utilities/datetime';
import { TOP_ALERT_TYPES } from '../../constants/types';

const TopNavAlertComponent = ({ alertInfo }) => {
  const navigate = useNavigate();
  const syncTime = getSyncTime();

  const getHeading = (type) => {
    if (type === TOP_ALERT_TYPES.SYNC) {
      return 'Data sync is in progress.'
    } else if (type === TOP_ALERT_TYPES.FIRSTSYNC) {
      return 'Data sync is in progress. You will be able to see the data in a while.'
    } else if (type === TOP_ALERT_TYPES.SNAPSHOT) {
      return `You are currently viewing data from [${getDateTimeFromTimestamp(
        syncTime
      )}].`
    } else if (type === TOP_ALERT_TYPES.ACCOUNTSYNCOFF) {
      return 'This account has sync turned off'
    }
  }

  const getHeadingLink = (type) => {
    if (type === TOP_ALERT_TYPES.SNAPSHOT) {
      return 'Click To Exit Snapshot view.'
    } else if (type === TOP_ALERT_TYPES.ADDACCOUNT) {
      return 'Click here to add Account'
    } else if (type === TOP_ALERT_TYPES.ACCOUNTSYNCOFF) {
      return ''
    }
  }

  const handleRequest = (type) => {
    if (type === TOP_ALERT_TYPES.SNAPSHOT) {
      clearSnapshot();
      navigate('/snapshots');
      var removeIndex = alertInfo.map(item => item.type).indexOf(TOP_ALERT_TYPES.SNAPSHOT);
      removeIndex && alertInfo.splice(removeIndex, 1);
    } else if (type === TOP_ALERT_TYPES.ADDACCOUNT) {
      navigate('/defi/accounts');
    }
  };

  return (
    <IconSettings iconPath="/assets/icons">
      {alertInfo && (
        <AlertContainer>
          {
            alertInfo.map((item, id) => (
              <Alert
                key={id}
                labels={{
                  heading: getHeading(item.type),
                  headingLink: getHeadingLink(item.type),
                }}
                onClickHeadingLink={() => handleRequest(item.type)}
                variant={item.variant}
                icon={<Icon category="utility" name={item.icon} size="large" />}
              />
            ))
          }
        </AlertContainer>
      )}
    </IconSettings>
  );
};

export default TopNavAlertComponent;
